// Project wide constants here

export const GENERIC_ERROR_MSG = 'Something went wrong, please try again';
export const GENERIC_ERROR_LOAD_MSG = 'Could not fetch the data, please try again';
export const INVALID_FILENAME_REGEX = /[!@#$%^&*(),?":{}|<>\s]/g;